var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.2V5.5H10.2L18.5 13.8C19.3 14.6 19.3 15.8 18.5 16.6L15.6 19.5C14.8 20.3 13.6 20.3 12.8 19.5L4.5 11.2V9.2Z",
    stroke: "#FFFFFF",
    strokeWidth: 1.7,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.1,
    cy: 8.1,
    r: 1.2,
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9 4.8L16.4 6.2L17.8 6.7L16.4 7.2L15.9 8.6L15.4 7.2L14 6.7L15.4 6.2L15.9 4.8Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandsIcon);
export default __webpack_public_path__ + "static/media/brands-icon.af6f18953edd25c4276c9a2094629925.svg";
export { ForwardRef as ReactComponent };